<template>
<div>
  <v-card
    color="cloud"
    tile
    class="d-flex align-center pa-2"
  >
    <v-badge
      :content="notify_nums"
      :value="notify_nums>0"
      color="deepLava"
      overlap
    >
      <v-icon color="white">mdi-bell</v-icon>
    </v-badge>
    <p style="color:white" class="my-0">全体通知</p>
    <v-btn class="ml-auto" rounded color="#008CFF" dark @click="$emit('openModal', null)">表示</v-btn>
  </v-card>
  <v-list class="py-0 mt-0" style="width:300px; max-height:400px; z-index:5000; background-color:white; overflow: hidden scroll;" v-if="notify.length>0">
    <v-list-item three-line v-for="(item, index) in notify" :key="item.sort">
      <v-list-item-content>
        <v-list-item-title class="d-flex" style="color:#2B2B2B">
          <v-icon color="deepLava" size="small" v-if="item.isNew">mdi-circle</v-icon>
          <span class="my-auto" style="white-space: pre-wrap; max-width: 250px;">{{ item.title }}</span>
          <!-- もしitem.isImportantなら赤にしたい -->
          <v-chip :color="item.isImportant?'#BA0009':'#399942'" dark class="ml-auto"><span v-text="item.tag"></span></v-chip>
        </v-list-item-title>
        <!-- <div style="color:#2B2B2B" class="my-2" v-html="item.content"></div> -->
        <v-list-item-subtitle class="d-flex align-center">
          <v-btn @click="$emit('openModal', index)" text style="background-color:#dcdcdc; font-size:10px;">確認する</v-btn>
          <span class="ml-auto"></span><span v-if="item.createdAt" v-text="item.createdAt.toDate().toLocaleString()"></span><span v-if="item.created" v-text="item.created.toDate().toLocaleString()"></span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
  <div v-else style="background-color:white">
    <p class="text-center py-4 mb-0">通知はありません。</p>
  </div>
</div>
</template>

<script>
  import firebase from 'firebase'
  export default ({
    props: {
      isSp: Boolean,
    },
    data () {
      return {
      db:null,
      notiDesk: false,
      notiMob: false,
      notiLine: false,
      toUser: "all",
      content:"",
      toTheUser: "",
    }},
    computed:{
      admins(){
        return this.$store.state.admins
      },
      liqAdmins(){
        return this.$store.state.liqAdmins
      },
      namelist(){
        return this.$store.state.namelist
      },
      isAdmin(){
        return this.$store.state.isAdmin
      },
      basetitle(){
        return this.$store.state.basetitle
      },
      lid(){
        return this.$store.state.lid
      },
      alid(){
        return this.$store.state.alid
      },
      config(){
        return this.$store.state.config
      },
      members(){
        return this.$store.state.members
      },
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
      currentName() {
        return this.$store.state.auth.user.displayName;
      },
      isAuthed() {
        return !this.$store.state.auth.user.isAnonymous || false;
      },
      notify(){
        return this.$store.state.notifys
      },
      notify_nums(){
        return this.$store.state.notify_nums
      },
    },
    created(){
      this.db = firebase.firestore()
      //console.log("created",this.pageTitle,this.currentName,this.uid)
    },
    mounted(){
  
    },
    watch:{
    }, 
    methods: {

    }
  })
  </script>
  
  <style scoped>
  *{
    font-family:mplus-2c-medium;
  }
  
  </style>